export const FILTER_BY_CATEGORY = 'FILTER_BY_CATEGORY';
export const FILTER_BY_SERVICES = 'FILTER_BY_SERVICES';
export const FILTER_BY_SECTORS = 'FILTER_BY_SECTORS';
export const FILTER_BY_DEPARTMENTS = 'FILTER_BY_DEPARTMENTS';
export const FILTER_BY_LEVELS = 'FILTER_BY_LEVELS';
export const SEARCH_LIST_DEPARTMENT = 'SEARCH_LIST_DEPARTMENT';